"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var AuthScope_1 = require("./AuthScope");
exports.default = (_a = {},
    _a[AuthScope_1.default.AUTH] = "Auth",
    _a[AuthScope_1.default.PLATFORM] = "Platform",
    _a[AuthScope_1.default.CONNECTIONS] = "Connections",
    _a[AuthScope_1.default.PUBLISHERS] = "Publishers",
    _a[AuthScope_1.default.IP_BLOCKER] = "IP Blocker",
    _a[AuthScope_1.default.MONEY_BOOKER] = "Moneybooker",
    _a[AuthScope_1.default.ALGOTRADER] = "Algotrader",
    _a[AuthScope_1.default.SKYNET] = "Skynet",
    _a[AuthScope_1.default.AUTOSCALER] = "Autoscaler",
    _a[AuthScope_1.default.NIGHTWATCH] = "Nightwatch",
    _a[AuthScope_1.default.DISPLAY] = "Display",
    _a[AuthScope_1.default.OPEN_RTB] = "Open RTB",
    _a[AuthScope_1.default.ADVERTISERS] = "Advertisers",
    _a[AuthScope_1.default.DSP_GATEWAY] = "SDP Gateway",
    _a[AuthScope_1.default.CAPTAINS_LOG] = "Captains Log",
    _a[AuthScope_1.default.BI] = "BI",
    _a[AuthScope_1.default.CONTENT] = "Content",
    _a[AuthScope_1.default.CAPCHU] = "Capchu",
    _a[AuthScope_1.default.CAMPAIGN_DUPLICATOR] = "Campaign Duplicator",
    _a[AuthScope_1.default.VAULT] = "Vault",
    _a[AuthScope_1.default.NETWORK] = "Network",
    _a[AuthScope_1.default.VROKU] = "Vroku",
    _a[AuthScope_1.default.MESSAGES] = "Messages",
    _a[AuthScope_1.default.REPORTING] = "Reporting",
    _a[AuthScope_1.default.BI_DASHBOARD] = "BI Dashboard",
    _a[AuthScope_1.default.BI_DASHBOARDS] = "BI Dashboard V2",
    _a[AuthScope_1.default.GAMES] = "Games",
    _a[AuthScope_1.default.VPM] = "VPM",
    _a[AuthScope_1.default.KIBANA] = "Kibana",
    _a[AuthScope_1.default.WEB_DIRECTORY] = "Web Directory",
    _a[AuthScope_1.default.SITES] = "Sites",
    _a[AuthScope_1.default.FEATURE_TOGGLES] = "Feature Toggles",
    _a[AuthScope_1.default.USER_NOTIFICATIONS] = "User Notifications",
    _a[AuthScope_1.default.ENTERPRISE] = "Enterprise",
    _a);
